import PdfViewer from 'components/shared/PdfViewer';
import { FunctionComponent, useEffect } from 'react';

const SustainabilityReportPage: FunctionComponent = () => {
  useEffect(() => {
    document.dispatchEvent(new Event('page-fetched'));
  }, []);

  return <PdfViewer url="/docs/sustainability-report.pdf" />;
};

export default SustainabilityReportPage;
